export enum ClinicsTableView {
  ACTIVE,
  ARCHIVE,
}
